"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeString = void 0;
exports.capitalizeString = (str = '') => {
    const strArr = str ? str.split(" ") : [];
    return strArr
        .map(word => word
        .charAt(0)
        .toUpperCase()
        .concat(word.slice(1).toLowerCase()))
        .join(" ")
        .trim();
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/util/capitalize-string.ts
// module id = 131
// module chunks = 0